/**
 * Regra de quem entra só para registrar solicitações de compra.
 *
 * Papel: `soTemSolicitacaoDeCompra` diz se o acesso da pessoa é o do funcionário
 * da casa, com a única permissão concedida sendo a do módulo
 * `solicitacao-de-compra`, em qualquer nível.
 *
 * Como usar: a tela inicial redireciona esse acesso para `/solicitar-compra`, e
 * a barra superior esconde o menu de módulos. Administrador nunca cai aqui,
 * porque `eAdministrador` vence a lista de permissões, e quem não tem nenhuma
 * permissão continua vendo a tela inicial vazia, com o aviso de módulos
 * liberados.
 */
import { type Acesso } from '@concierge/shared';

/**
 * Diz se a única permissão do acesso é a de solicitação de compra.
 *
 * @param acesso - Resposta de `GET /api/sessao`, ou só a parte que a regra lê.
 * @returns Verdadeiro quando a pessoa não é administradora e a lista de
 *   permissões tem ao menos uma entrada, todas do módulo `solicitacao-de-compra`.
 */
export function soTemSolicitacaoDeCompra(
  acesso: Pick<Acesso, 'eAdministrador' | 'permissoes'>,
): boolean {
  if (acesso.eAdministrador) return false;
  return (
    acesso.permissoes.length > 0 &&
    acesso.permissoes.every((permissao) => permissao.modulo === 'solicitacao-de-compra')
  );
}
